import { Avatar } from '@crehana/compass.ui/v3/avatar';
import { createColumns } from '@crehana/compass.ui/v3/table';
import { useTranslation } from '../i18n';
import type { TCollaboratorRow } from '../types';
import { ShiftTagCell } from './shift-tag-cell';
import { WorkedHoursCell } from './worked-hours-cell';

export const useCollaboratorsColumns = () => {
  const { t } = useTranslation();

  const columns = createColumns<TCollaboratorRow>(({ column, cells }) => [
    column.expand(),
    column.accessor('name', {
      header: t('COLUMN_COLLABORATOR'),
      cell: cells.text(row => ({
        title: row.name,
        subtitle: row.role,
        bold: true,
        leading: (
          <Avatar
            size="sm"
            // TODO: add avatar url once backend is updated
            // src={row.avatarUrl}
            userName={row.name}
          />
        ),
      })),
    }),
    column.accessor('shiftName', {
      header: t('COLUMN_SHIFT'),
      cell: info => (
        <ShiftTagCell
          name={info.row.original.shiftName}
          color={info.row.original.shiftColor}
        />
      ),
    }),
    column.accessor('workedHoursFormatted', {
      header: t('COLUMN_WORKED_HOURS'),
      cell: info => (
        <WorkedHoursCell
          workedHours={info.row.original.workedHoursFormatted}
          scheduledHours={info.row.original.scheduledHoursFormatted}
          percentage={info.row.original.workedPercentage}
        />
      ),
    }),
    column.accessor('overtimeFormatted', {
      header: t('COLUMN_OVERTIME'),
      cell: info => (
        <span className="tw-cds-font-subtitle-01 tw-cds-text-success">
          {info.row.original.overtimeFormatted}
        </span>
      ),
    }),
    column.accessor('lateHoursFormatted', {
      header: t('COLUMN_LATE_HOURS'),
      cell: info => (
        <span className="tw-cds-font-subtitle-01 tw-cds-text-alert">
          {info.row.original.lateHoursFormatted}
        </span>
      ),
    }),
  ]);

  return columns;
};
